import React,{useEffect} from 'react'
import { useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { getActivePrice } from "../../utils/converter";
import {getAllProductsAction} from "../../store/product/actions"
import Layout from "../layout/Layout"
import './products.css';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const Productsskeleton = ({cards}:any) => {
  
 
   
  console.log(Array(6).fill(0))
  return (
    <>
          {Array(cards).fill(0).map((d: any, index: number) => (
              <div className="single-products-catagory clearfix " id="single-products-catagory" key={index} >
                      <a href="#">
                          <Skeleton width={388} height={388}/>
                          <div className="hover-content">
                              <div className="line"></div>
                              <p><Skeleton /></p>
                              <h4><Skeleton /></h4>
                          </div>
                      </a>
              </div>
          ))}
        </>
  )
}

export default Productsskeleton